// Webpack Imports
import * as bootstrap from 'bootstrap'
;(function () {
  ;('use strict')

  let width = window.innerWidth

  // Passive event listeners
  jQuery.event.special.touchstart = {
    setup: function (_, ns, handle) {
      this.addEventListener('touchstart', handle, { passive: !ns.includes('noPreventDefault') })
    }
  }
  jQuery.event.special.touchmove = {
    setup: function (_, ns, handle) {
      this.addEventListener('touchmove', handle, { passive: !ns.includes('noPreventDefault') })
    }
  }

  // Focus input if Searchform is empty
  // ;[].forEach.call(document.querySelectorAll('.search-form'), el => {
  //   el.addEventListener('submit', function (e) {
  //     var search = el.querySelector('input')
  //     if (search.value.length < 1) {
  //       e.preventDefault()
  //       search.focus()
  //     }
  //   })
  // })

  // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
  var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
  var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl, {
      trigger: 'focus'
    })
  })

  // Searchbar
  const searchBtn = document.getElementById('searchBtn')
  const closeBtn = document.getElementById('closeBtn')
  const searchBar = document.getElementById('searchBar')
  const searchInput = document.getElementById('searchInput')

  searchBtn.addEventListener('click', e => {
    searchBar.style.transform = 'translateY(0)'
    searchInput.focus()
  })

  closeBtn.addEventListener('click', e => {
    searchBar.style.transform = 'translateY(-100%)'
  })

  // Mobile menu
  const header = document.querySelector('header')
  const toggler = document.querySelector('.toggler')
  const mobileMenu = document.querySelector('.mobile-menu')
  const mobileNav = document.querySelector('.mobile-nav')
  const nlimg = document.getElementById('nlimg')

  toggler.addEventListener('click', e => {
    if (toggler.checked) {
      header.style.backgroundPosition = 'left bottom'
      mobileMenu.style.width = '100%'
      nlimg.style.transform = 'translateX(0%)'
      mobileNav.classList.add('open')
      document.body.style.overflow = 'hidden'

      window.scrollTo({
        top: 0
      })
    } else {
      header.style.backgroundPosition = 'right bottom'
      nlimg.style.transform = 'translateX(-100%)'
      mobileMenu.style.width = '0%'
      mobileNav.classList.remove('open')
      document.body.style.overflow = 'visible'
    }
  })

  window.addEventListener('resize', function () {
    let win = this
    if (win.innerWidth > 1200) {
      toggler.checked = false
      header.style.backgroundPosition = 'right bottom'
      nlimg.style.transform = 'translateX(-100%)'
      mobileMenu.style.width = '0%'
      mobileNav.classList.remove('open')
      document.body.style.overflow = 'visible'
    }
  })

  // Werkplaatsen Slider Nav
  if (document.body.classList.contains('home')) {
    const navLeft = document.getElementById('wp-nav-left')
    const navRight = document.getElementById('wp-nav-right')

    navLeft.addEventListener('click', e => {
      e.preventDefault()

      jQuery('.wp-slider').slick('slickPrev')
    })

    navRight.addEventListener('click', e => {
      e.preventDefault()

      jQuery('.wp-slider').slick('slickNext')
    })
  }

  // const langModeCheckbox = document.querySelector("input[name='lang-mode']")
  // const switchBtn = document.querySelector('.btn-lang-switch')
  // const currentLanguage = wpml_current_language()

  // switchBtn.addEventListener('click', function () {
  //   if (currentLanguage === 'nl') {
  //     window.location.href = wpml_element_link(document.querySelector('body'), 'de')
  //   } else {
  //     window.location.href = wpml_element_link(document.querySelector('body'), 'nl')
  //   }
  // })

  // // Taal wisselaar
  // const langMode = document.getElementById('lang-mode')
  // const languageSelect = document.getElementById('language-select')

  // langMode.addEventListener('change', function () {
  //   if (this.checked) {
  //     // switch to German language
  //     const deId = icl_object_id(get_the_ID(), 'page', false, 'de')
  //     window.location.href = get_permalink(deId)
  //   } else {
  //     // switch to Dutch language
  //     const nlId = icl_object_id(get_the_ID(), 'page', false, 'nl')
  //     window.location.href = get_permalink(nlId)
  //   }
  // })

  // languageSelect.addEventListener('change', function () {
  //   const selectedLanguage = this.value
  //   if (selectedLanguage !== '') {
  //     const selectedId = icl_object_id(get_the_ID(), 'page', false, selectedLanguage)
  //     window.location.href = get_permalink(selectedId)
  //   }
  // })

  // const langMode = document.getElementById('lang-mode')

  // langMode.addEventListener('change', function () {
  //   if (this.checked) {
  //     // switch to German language
  //     const translatedPostId = wpmlData.languages.de.post_id[wpmlData.currentPostId]
  //     window.location.href = `/?p=${translatedPostId}`
  //   } else {
  //     // switch to Dutch language
  //     const translatedPostId = wpmlData.languages.nl.post_id[wpmlData.currentPostId]
  //     window.location.href = `/?p=${translatedPostId}`
  //   }
  // })

  document.addEventListener(
    'wpcf7mailsent',
    function (event) {
      setTimeout(function () {
        jQuery('.wpcf7-response-output').delay(3000).fadeOut('slow').hide(0)
      }, 5000)
    },
    false
  )

 // GSAP
gsap.registerPlugin(ScrollTrigger);

if (document.body.classList.contains('home')) {
    let tl = gsap.timeline();

    // Sequenced one-after-the-other
    tl.from('header', {
        duration: 1,
        top: -181,
        autoAlpha: 0,
    })
    .from('.hero-home__content', {
    duration: 1,
    x: -100,
    autoAlpha: 0,
    }, '-=1')
    .from('.hero-home__card', {
        y: 100,
        autoAlpha: 0,
        stagger: {
            each: 0.1,
        },
    }, '-=1');
}


  if (!document.body.classList.contains('home')) {
    let tl = gsap.timeline()
    //sequenced one-after-the-other
    tl.from('header', {
      duration: 0.5,
      top: -181,
      autoAlpha: 0
    })
      .from(
        '.hero__content__container',
        {
          duration: 0.5,
          x: -100,
          autoAlpha: 0
        },
        '-=0.5'
      );
  }
  

  var scrollToTopBtn = document.querySelector('.scrollToTopBtn')
  var rootElement = document.documentElement

  function handleScroll() {
    // Do something on scroll
    var scrollTotal = rootElement.scrollHeight - rootElement.clientHeight
    if (rootElement.scrollTop / scrollTotal > 0.7) {
      // Show button
      scrollToTopBtn.classList.add('showBtn')
    } else {
      // Hide button
      scrollToTopBtn.classList.remove('showBtn')
    }
  }

  function scrollToTop() {
    // Scroll to top logic
    rootElement.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }
  scrollToTopBtn.addEventListener('click', scrollToTop)
  document.addEventListener('scroll', handleScroll)
})()
